module.exports = __webpack_public_path__ + "static/media/manzo_02_thumb_hover.5e287d90.png";